import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import DateBlock from './date-block'
import Table from './table'
import GameModal from '../../containers/game-modal'
import FacilityOpenGameModal from '../../containers/facility-open-game-modal'

function Activities({selectedDate, records, socketUrl, onDateChange}) {
  const [showGame, setShowGame] = useState(null)
  const [showFacilityOpenGame, setShowFacilityOpenGame] = useState(null)

  const onShowGame = (record) => {
    record.open_game ? setShowFacilityOpenGame(record.game_id) : setShowGame(record.game_id)
  }

  return <div>
    { showGame &&
      <GameModal
        gameId={showGame}
        socketUrl={socketUrl}
        onClose={() => setShowGame(null)}
      /> 
    }
    { showFacilityOpenGame &&
      <FacilityOpenGameModal
        gameId={showFacilityOpenGame}
        socketUrl={socketUrl}
        onClose={() => setShowFacilityOpenGame(null)}
      /> 
    }
    <DateBlock selectedDate={selectedDate} onDateChange={onDateChange} />
    <Table records={records} onShowGame={onShowGame} />
  </div>
}

Activities.propTypes = {
  selectedDate: PropTypes.string.isRequired,
  records: PropTypes.array.isRequired,
  socketUrl: PropTypes.string.isRequired,
  onDateChange: PropTypes.func.isRequired,
}

export default Activities
